export const ROOM_NAME_BLACK_LIST = [
  'confirmation',
  'contact',
  'forgot_password',
  'help',
  'privacy_policy',
  'reset_password',
  'sign_in',
  'sign_up',
  'user_policy'
]

export function urlAutoLink(text) {
  return text.replace(/(http(s)?:\/\/[a-zA-Z0-9-.!'()*;/?:@&=+$,%_#]+)/gi, "<a href='$1' target='_blank'>$1</a>")
}

export function dateToString({date, type = 0}) {
  if (!date) date = new Date()
  const year = date.getFullYear()
  const month = ('00' + (date.getMonth() + 1)).slice(-2)
  const day = ('00' + (date.getDate())).slice(-2)
  const hours = ('00' + (date.getHours())).slice(-2)
  const minutes = ('00' + (date.getMinutes())).slice(-2)
  let dateString

  switch (type) {
    case 0:
      dateString = `${year}-${month}-${day}`
      break
    case 1:
      dateString = `${year}-${month}-${day} ${hours}:${minutes}`
      break
    case 2:
      dateString = `${hours}:${minutes}`
      break
  }
  return dateString
}
